<template>
  <div class="clock-container" :style="{ backgroundColor: containerColor, color: textColor }">
    <div class="clock">
      <span>{{ time }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    textColor: {
      type: String,
      default: '#f9f9f9'
    },
    containerColor: {
      type: String,
      default: 'transparent'
    }
  },
  data() {
    return {
      time: '',
    };
  },
  mounted() {
    this.updateTime();
    this.interval = setInterval(this.updateTime, 1000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    updateTime() {
      const now = new Date();
      this.time = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    },
  },
};
</script>

<style scoped>
.clock-container {
  padding: 10px;
  text-align: center;
  /* box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); */
}

.clock {
  font-size: 18px;
  font-weight: bold;
}
</style>
